import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from "@shared/components/cell-components/cell-component";
import {FieldDefinition} from "@shared/models/field-definition";

@Component({
    standalone: false,
    selector: 'particle-confirmation-receipt-cell-viewer',
  templateUrl: './confirmation-receipt-cell-viewer.component.html',
  styleUrls: ['./confirmation-receipt-cell-viewer.component.scss']
})
export class ConfirmationReceiptCellViewerComponent implements OnInit, CellComponent {

  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();
  fieldDefinition: FieldDefinition;
  item: any;

  constructor() { }

  ngOnInit(): void {
  }

  onClicked(action: string) {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: action}});
  }

}
